module.exports = __webpack_public_path__ + "static/media/comments.eba37c00.PNG";